export default __webpack_public_path__ + "static/media/20220821_151741 - Prikshit Anthal.17cbc017.jpg";